/* Deniz Doğal Taş — Test tanımları 1/3: Gökyüzü ve Sayı
 * Burcunu Keşfet · Doğum Haritası · Yıldızname · Numeroloji · Marifetnâme
 */
(function () {
  "use strict";
  var T = (window.DENIZ_TESTLER = window.DENIZ_TESTLER || {});
  var Z = window.DZ;

  /* ============ 1. BURCUNU KEŞFET ============ */

  // Nitelik (modalite) yorumları — öncü / sabit / değişken
  var NITELIK = {
    oncu:     { ad: "Öncü", metin: "Başlatma enerjisi taşıyorsun. Bir şeyin ilk adımını atmak sana doğal geliyor; sürdürmek başka bir mesele." },
    sabit:    { ad: "Sabit", metin: "Sürdürme enerjisi taşıyorsun. Başlanmış olanı sonuna kadar götürürsün; yön değiştirmek sana pahalıya gelir." },
    degisken: { ad: "Değişken", metin: "Uyarlama enerjisi taşıyorsun. Koşul değiştiğinde sen de değişirsin; bu esneklik seni ayakta tutar ama bazen köksüz bırakır." },
  };
  var BURC_NITELIK = {
    "Koç": "oncu", "Yengeç": "oncu", "Terazi": "oncu", "Oğlak": "oncu",
    "Boğa": "sabit", "Aslan": "sabit", "Akrep": "sabit", "Kova": "sabit",
    "İkizler": "degisken", "Başak": "degisken", "Yay": "degisken", "Balık": "degisken",
  };

  T["burcunu-kesfet"] = {
    ad: "Burcunu Keşfet",
    ustBaslik: "Gökyüzü Haritası",
    kapak: "kapak-burcunu-kesfet.png",
    video: "zodyak-dongu.mp4",
    ozet: "Aynı burçtan iki kişi asla aynı değildir. Doğum tarihin burcunu verir; on iki soru ise o burcu nasıl taşıdığını gösterir — niteliğini, gölge yönünü ve özün ile tavrın arasındaki mesafeyi.",
    sure: "4 dakika",
    ciktiEtiket: "Gölge okuması",
    girdiler: ["ad", "dogumTarihi", "cinsiyet"],
    hesapSatirlari: [
      "Doğum tarihin ekliptik üzerine yerleştiriliyor…",
      "Güneş'in bulunduğu burç kapısı okunuyor…",
      "On iki cevabın element dağılımı tartılıyor…",
      "Nitelik ekseni hesaplanıyor…",
      "Öz ile tavır arasındaki mesafe ölçülüyor…",
      "Gölge yön belirleniyor…",
      "Taş karşılıkları hizalanıyor…",
    ],
    sorular: [
      { metin: "Kalabalık bir odaya girdiğinde ilk ne yaparsın?",
        secenekler: [
          { etiket: "Söze ben başlarım, ortamı ben kurarım", puan: { ates: 3 } },
          { etiket: "Önce izlerim, kimin ne olduğunu anlarım", puan: { toprak: 3 } },
          { etiket: "Herkesle tek tek konuşur, bağ kurarım", puan: { hava: 3 } },
          { etiket: "Odanın havasını hissederim, sezerim", puan: { su: 3 } },
        ] },
      { metin: "Bir karar verirken sana asıl yol gösteren nedir?",
        secenekler: [
          { etiket: "İçimden gelen ilk dürtü", puan: { ates: 3 } },
          { etiket: "Somut veri ve geçmiş deneyim", puan: { toprak: 3 } },
          { etiket: "Mantık yürütme ve karşılaştırma", puan: { hava: 3 } },
          { etiket: "İçime doğan his", puan: { su: 3 } },
        ] },
      { metin: "Seni en çok ne yorar?",
        secenekler: [
          { etiket: "Beklemek ve yavaşlık", puan: { ates: 3 } },
          { etiket: "Belirsizlik ve düzensizlik", puan: { toprak: 3 } },
          { etiket: "Tekrar ve monotonluk", puan: { hava: 3 } },
          { etiket: "Duygusuz, mesafeli ortamlar", puan: { su: 3 } },
        ] },
      { metin: "Yeni bir işe başlarken tipik hâlin?",
        aciklama: "İlk hafta seni düşün.",
        secenekler: [
          { etiket: "Hemen başlarım, planı yolda kurarım", puan: { ates: 2, oncu: 3 } },
          { etiket: "Sonuna kadar götüreceğime karar verip girerim", puan: { toprak: 2, sabit: 3 } },
          { etiket: "Koşullara göre şeklini değiştiririm", puan: { hava: 2, degisken: 3 } },
          { etiket: "İçime sinmesini beklerim, sonra başlarım", puan: { su: 2, sabit: 2 } },
        ] },
      { metin: "Bir tartışmanın ortasındasın. Ne yaparsın?",
        secenekler: [
          { etiket: "Karşı çıkarım, sesim yükselir", puan: { ates: 3 } },
          { etiket: "Susar, sonra tek tek hesaplaşırım", puan: { toprak: 2, sabit: 2 } },
          { etiket: "Mantıkla çözmeye çalışırım", puan: { hava: 3 } },
          { etiket: "Ortamdan uzaklaşırım, içime kapanırım", puan: { su: 3 } },
        ] },
      { metin: "Sevdiğine sevgini nasıl gösterirsin?",
        secenekler: [
          { etiket: "Harekete geçerek, onun için bir şey yaparak", puan: { ates: 2, oncu: 2 } },
          { etiket: "Yanında kalarak, güven vererek", puan: { toprak: 3, sabit: 2 } },
          { etiket: "Konuşarak, anlatarak, paylaşarak", puan: { hava: 3 } },
          { etiket: "Hissederek, sezerek, sormadan anlayarak", puan: { su: 3 } },
        ] },
      { metin: "Plan bozulduğunda?",
        secenekler: [
          { etiket: "Yeni bir plan uydururum, hemen", puan: { ates: 2, degisken: 2 } },
          { etiket: "Sinirlenirim, düzeni geri kurmaya çalışırım", puan: { toprak: 3, sabit: 3 } },
          { etiket: "Alternatifleri sıralarım", puan: { hava: 3, degisken: 2 } },
          { etiket: "Kabullenirim, akışa bırakırım", puan: { su: 2, degisken: 3 } },
        ] },
      { metin: "Hangi eleştiri sana en çok dokunur?",
        secenekler: [
          { etiket: "\"Fazla sertsin\"", puan: { ates: 3 } },
          { etiket: "\"Fazla inatçısın\"", puan: { toprak: 3, sabit: 3 } },
          { etiket: "\"Fazla soğuksun\"", puan: { hava: 3 } },
          { etiket: "\"Fazla hassassın\"", puan: { su: 3 } },
        ] },
      { metin: "Boş bir günün var. Ne yaparsın?",
        secenekler: [
          { etiket: "Plansız çıkar, bir şeyler olsun isterim", puan: { ates: 3, degisken: 2 } },
          { etiket: "Evde düzen kurar, biriken işleri bitiririm", puan: { toprak: 3 } },
          { etiket: "Birileriyle buluşur, konuşurum", puan: { hava: 3 } },
          { etiket: "Yalnız kalır, dinlenir, hayal kurarım", puan: { su: 3 } },
        ] },
      { metin: "Uzun süredir istediğin bir şeye kavuşmak üzeresin. Son anda?",
        secenekler: [
          { etiket: "Sabırsızlanır, hızlandırmaya çalışırım", puan: { ates: 3, oncu: 2 } },
          { etiket: "Elimden kaçmasın diye sıkı tutarım", puan: { toprak: 2, sabit: 3 } },
          { etiket: "Aklıma başka ihtimaller gelir", puan: { hava: 3, degisken: 3 } },
          { etiket: "Bir şey ters gidecek diye endişelenirim", puan: { su: 3 } },
        ] },
      { metin: "İnsanlar seni ilk tanıdığında ne der?",
        secenekler: [
          { etiket: "Enerjik, doğrudan", puan: { ates: 3, oncu: 2 } },
          { etiket: "Sakin, güvenilir", puan: { toprak: 3, sabit: 2 } },
          { etiket: "Sohbeti iyi, zeki", puan: { hava: 3 } },
          { etiket: "Sıcak ama mesafeli", puan: { su: 3 } },
        ] },
      { metin: "Hayatında en çok tekrar eden örüntü hangisi?",
        aciklama: "Dürüst ol — bu soru sonucun en belirleyici kısmı.",
        secenekler: [
          { etiket: "Başlıyorum, bitirmiyorum", puan: { ates: 3, oncu: 3 } },
          { etiket: "Bırakmam gerekeni bırakamıyorum", puan: { toprak: 3, sabit: 3 } },
          { etiket: "Dağılıyorum, odaklanamıyorum", puan: { hava: 3, degisken: 3 } },
          { etiket: "Herkesin yükünü taşıyorum", puan: { su: 3 } },
        ] },
    ],
    sonuc: function (girdi, cevaplar) {
      var burc = Z.burcBul(girdi.dogumTarihi);
      var b = Z.BURCLAR[burc];
      var D = (window.DZ_BURC_DERIN || {})[burc] || {};
      var ad = Z.ilkAd(girdi.ad);

      var tum = Z.puanTopla(cevaplar);
      var elPuan = { ates: tum.ates || 0, toprak: tum.toprak || 0, hava: tum.hava || 0, su: tum.su || 0 };
      var nitPuan = { oncu: tum.oncu || 0, sabit: tum.sabit || 0, degisken: tum.degisken || 0 };

      var elAd = { ates: "Ateş", toprak: "Toprak", hava: "Hava", su: "Su" };
      var davranisEl = elAd[Z.baskin(elPuan)] || b.el;
      var uyumlu = davranisEl === b.el;

      var dogalNit = BURC_NITELIK[burc];
      var cevapNit = Z.baskin(nitPuan) || dogalNit;
      var N = NITELIK[dogalNit], CN = NITELIK[cevapNit];

      // En zayıf element = beslenmesi gereken taraf
      var zayifEl = elAd[Object.keys(elPuan).sort(function (a, c) { return elPuan[a] - elPuan[c]; })[0]];

      var taslar = Z.birlestir(
        Z.BURC_TAS[burc].slice(0, 3),
        Z.ELEMENT_TAS[b.el].slice(0, 2),
        uyumlu ? [] : Z.ELEMENT_TAS[davranisEl].slice(0, 2),
        Z.ELEMENT_TAS[zayifEl].slice(0, 2)
      );

      var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};
      var gerekceler = taslar.slice(0, 6).map(function (a) {
        var t = bilgi[a] || {};
        var neden;
        if ((Z.BURC_TAS[burc] || []).indexOf(a) !== -1) neden = burc + " burcuyla geleneksel olarak anılan taş. " + (t.ozet || "");
        else if ((Z.ELEMENT_TAS[b.el] || []).indexOf(a) !== -1) neden = "Güneş elementin " + b.el + "'i besliyor. " + (t.ozet || "");
        else if (!uyumlu && (Z.ELEMENT_TAS[davranisEl] || []).indexOf(a) !== -1) neden = "Cevaplarından çıkan " + davranisEl + " tavrını destekliyor. " + (t.ozet || "");
        else neden = "Haritanda en zayıf kalan " + zayifEl + " elementini dengelemek için. " + (t.ozet || "");
        return { ad: t.ad || a, renk: t.renk, metin: neden };
      });

      return {
        ustBaslik: "Güneş Burcun",
        baslik: burc,
        simge: b.simge,
        altBaslik: b.el + " · " + N.ad + " · " + b.yonetici + " yönetiminde",
        vurgu: D.cekirdek || "",
        rozetler: [
          { etiket: "Element", deger: b.el },
          { etiket: "Nitelik", deger: N.ad },
          { etiket: "Yönetici", deger: b.yonetici },
          { etiket: "Tavrın", deger: davranisEl },
        ],
        metin: [
          ad + ", doğduğun gün Güneş " + burc + " burcundaydı. Bu haritanın çekirdeği — özün, kimliğin ve hayata bakış açının kurulduğu yer. Ama burç tek başına bir insanı anlatmaz; asıl mesele o burcu nasıl yaşadığındır. On iki cevabın bunu gösterdi.",
        ],
        bolumler: [
          { baslik: "Özün", paragraflar: [D.oz || ""] },
          { baslik: "Nitelik ekseni",
            paragraflar: [
              burc + " " + N.ad.toLocaleLowerCase("tr") + " bir burçtur. " + N.metin,
              cevapNit === dogalNit
                ? "Cevapların da " + CN.ad.toLocaleLowerCase("tr") + " çıktı; burcunun niteliğini olduğu gibi yaşıyorsun. Bu, kendinle çelişmeyen bir yapı demektir."
                : "Cevapların ise " + CN.ad.toLocaleLowerCase("tr") + " çıktı. Doğuştan " + N.ad.toLocaleLowerCase("tr") + " olan biri, hayat şartları yüzünden " + CN.ad.toLocaleLowerCase("tr") + " davranmayı öğrenmiş olabilir. " + CN.metin + " Bu uyum sağlama bir beceri ama bedeli var: kendi doğal ritminden uzak yaşamak sürekli düşük seviyeli bir yorgunluk üretir.",
            ] },
          { baslik: "Öz ile tavır arasındaki mesafe",
            vurgu: uyumlu ? "Özün ve tavrın aynı hizada." : "Özün " + b.el + ", tavrın " + davranisEl + ".",
            paragraflar: [
              uyumlu
                ? "Doğum haritan " + b.el + " diyor, cevapların da " + davranisEl + " çıktı. Bu nadir bir bütünlük: içinden geleni yaşıyorsun, kendini çevirmiyorsun. Avantajı net bir kimlik; riski ise tek yanlılık. " + b.el + " elementinin tüm gücünü ve tüm gölgesini tam dozunda taşıyorsun, ara ton az."
                : "Doğum haritan " + b.el + " diyor ama cevapların " + davranisEl + " çıktı. Bu, özünle dışa vurduğun tavır arasında bir mesafe olduğunu gösterir. Çoğu zaman sebebi şudur: bir dönem hayat senden " + davranisEl + " olmanı istedi ve sen bunu öğrendin. İyi de öğrendin — o kadar ki artık hangisinin gerçek sen olduğunu karıştırıyorsun. Bu bir kusur değil; ama farkında olunmadığında kimlik yorgunluğu yapar.",
              "Haritanda en zayıf kalan element " + zayifEl + ". Geleneksel yaklaşımda denge, baskın olanı bastırmakla değil eksik olanı beslemekle kurulur. Bu yüzden önerdiğim taşların bir kısmı doğrudan " + zayifEl + " elementini destekliyor.",
            ] },
          { baslik: "İlişkilerde sen", paragraflar: [D.iliski || ""] },
          { baslik: "Çalışma ve üretim", paragraflar: [D.calisma || ""] },
          { baslik: "Bu dönem", vurgu: D.donem || "", paragraflar: [] },
        ],
        golge: { baslik: "Gölge yönün", metin: D.golge || "" },
        olcumler: Z.olcumlereCevir(elPuan, elAd, { ates: "#F0A500", toprak: "#8B6914", hava: "#63B3ED", su: "#4FD1C5" }),
        gerekceler: gerekceler,
        taslar: taslar,
        urunGiris: burc + " burcu, " + b.el + " elementin ve eksik kalan " + zayifEl + " için seçilen stoklu ürünler:",
      };
    },
  };

  /* ============ 2. DOĞUM HARİTASI ============ */
  T["dogum-haritasi"] = {
    ad: "Doğum Haritası",
    ustBaslik: "Üç Işık",
    kapak: "kapak-dogum-haritasi.png",
    video: "zodyak-dongu.mp4",
    ozet: "Güneş kim olduğunu, Ay kimseye göstermediğin tarafını, Yükselen ise dünyanın seni ilk gördüğü yüzü anlatır. Üç ışığı birlikte okumak, tek başına burç bilmekten bambaşka bir şeydir.",
    sure: "5 dakika",
    ciktiEtiket: "Üç ışık okuması",
    girdiler: ["ad", "dogumTarihi", "dogumSaati", "dogumYeri"],
    hesapSatirlari: [
      "Doğum anı ekliptiğe yerleştiriliyor…",
      "Güneş'in burcu okunuyor…",
      "Ay'ın konumu hesaplanıyor…",
      "Yükselen ufuk çizgisi çıkarılıyor…",
      "Element ve nitelik dengesi tartılıyor…",
      "Üç ışık birbiriyle karşılaştırılıyor…",
      "Taş karşılıkları hizalanıyor…",
    ],
    sorular: [
      { metin: "Kimse seni görmüyorken nasıl birisin?",
        aciklama: "Bu soru Ay'ının nasıl çalıştığını gösterir.",
        secenekler: [
          { etiket: "Aynıyım, maskem yok", puan: { hizali: 3 } },
          { etiket: "Çok daha sessiz ve içe dönük", puan: { icerde: 3 } },
          { etiket: "Çok daha rahat ve neşeli", puan: { disarda: 3 } },
          { etiket: "Kaygılı, düşünceli", puan: { icerde: 2, kaygi: 2 } },
        ] },
      { metin: "Yeni tanıştığın biri seni nasıl tarif eder?",
        secenekler: [
          { etiket: "Sıcak ve yakın", puan: { disarda: 3 } },
          { etiket: "Mesafeli ve ölçülü", puan: { icerde: 3 } },
          { etiket: "Enerjik ve iddialı", puan: { disarda: 2, hizali: 2 } },
          { etiket: "Sakin ve gizemli", puan: { icerde: 2 } },
        ] },
      { metin: "Seni yakından tanıyanlar ne der?",
        secenekler: [
          { etiket: "Göründüğün gibisin", puan: { hizali: 3 } },
          { etiket: "Dışarıdan sandıklarından çok daha duygusalsın", puan: { icerde: 3 } },
          { etiket: "Sandıklarından çok daha sertsin", puan: { disarda: 2 } },
          { etiket: "Anlaşılması zor birisin", puan: { icerde: 2, kaygi: 2 } },
        ] },
      { metin: "Zor bir an geldiğinde ilk refleksin?",
        secenekler: [
          { etiket: "Harekete geçerim", puan: { hizali: 2 } },
          { etiket: "Kabuğuma çekilirim", puan: { icerde: 3 } },
          { etiket: "Birine anlatırım", puan: { disarda: 3 } },
          { etiket: "Her ihtimali düşünürüm", puan: { kaygi: 3 } },
        ] },
      { metin: "Duygularını ne kadar kolay gösterirsin?",
        secenekler: [
          { etiket: "Yüzümden okunur", puan: { disarda: 3 } },
          { etiket: "Çok yakınlarım bile zor anlar", puan: { icerde: 3 } },
          { etiket: "Gösteririm ama seçerek", puan: { hizali: 2 } },
          { etiket: "Göstermemeye çalışırım, sızar", puan: { kaygi: 2, icerde: 2 } },
        ] },
      { metin: "Kendini en çok ne zaman 'sen' gibi hissedersin?",
        secenekler: [
          { etiket: "Bir şey başarırken", puan: { hizali: 3 } },
          { etiket: "Yalnızken", puan: { icerde: 3 } },
          { etiket: "Sevdiklerimle birlikteyken", puan: { disarda: 3 } },
          { etiket: "Nadiren, çoğu zaman rol yapıyorum gibi", puan: { kaygi: 3 } },
        ] },
    ],
    sonuc: function (girdi, cevaplar) {
      var ad = Z.ilkAd(girdi.ad);
      var gunes = Z.burcBul(girdi.dogumTarihi);
      var ay = Z.ayBurcuKestir(girdi.dogumTarihi);
      var yukselen = Z.yukselenKestir(girdi.dogumTarihi, girdi.dogumSaati);

      var g = Z.BURCLAR[gunes], a = Z.BURCLAR[ay];
      var y = yukselen ? Z.BURCLAR[yukselen] : null;

      var elSayim = {};
      [g.el, a.el].concat(y ? [y.el] : []).forEach(function (e) { elSayim[e] = (elSayim[e] || 0) + 1; });
      var baskinEl = Z.baskin(elSayim);

      var taslar = Z.birlestir(
        Z.BURC_TAS[gunes].slice(0, 2),
        Z.BURC_TAS[ay].slice(0, 2),
        y ? Z.BURC_TAS[yukselen].slice(0, 2) : [],
        Z.ELEMENT_TAS[baskinEl]
      );

      var DG = window.DZ_BURC_DERIN || {};
      var Dg = DG[gunes] || {}, Da = DG[ay] || {}, Dy = yukselen ? (DG[yukselen] || {}) : {};

      var puan = Z.puanTopla(cevaplar);
      ["hizali", "icerde", "disarda", "kaygi"].forEach(function (k) { if (!puan[k]) puan[k] = 0; });
      var katman = Z.baskin(puan);

      var KATMAN = {
        hizali:  "Cevapların, üç ışığının birbirine yakın çalıştığını gösteriyor. İçeride ve dışarıda aynı kişisin. Bu nadir bir bütünlük; enerjini maske taşımaya harcamıyorsun.",
        icerde:  "Cevapların, Ay'ının Yükselen'inden çok daha baskın olduğunu gösteriyor. Dışarıya gösterdiğinden çok daha derin ve duygusal bir iç dünyan var. İnsanlar seni tanıdıkça şaşırır — çünkü ilk gördükleri yüzeyin sadece kapağıydı.",
        disarda: "Cevapların, Yükselen'inin Ay'ının önüne geçtiğini gösteriyor. Dışarıya güçlü ve rahat bir yüz gösteriyorsun; içerideki ihtiyaçlar ise sırada bekliyor. Bu, çevren için kolay ama senin için yorucu bir düzendir.",
        kaygi:   "Cevapların, üç ışık arasında bir uyumsuzluk olduğunu gösteriyor — kendini çoğu zaman 'rol yapıyormuş' gibi hissetmen bundan. Bu bir kimlik sorunu değil; Güneş'in, Ay'ın ve Yükselen'in farklı şeyler istediğinde ortaya çıkan doğal gerilim.",
      };

      var rozetler = [
        { etiket: "Güneş", deger: gunes },
        { etiket: "Ay", deger: ay },
        { etiket: "Yükselen", deger: y ? yukselen : "Saat gerekli" },
        { etiket: "Baskın element", deger: baskinEl },
      ];

      return {
        ustBaslik: "Doğum Haritan",
        baslik: gunes + " Güneş · " + ay + " Ay",
        altBaslik: (girdi.dogumYeri ? girdi.dogumYeri + " · " : "") + (girdi.dogumSaati || "saat belirtilmedi"),
        vurgu: "Burcunu bilmek seni tanımaz. Üç ışığın birlikte nasıl çalıştığı tanır.",
        rozetler: rozetler,
        metin: [
          ad + ", haritanda üç ışık var ve her biri seni bambaşka bir katmanda anlatır. Çoğu insan yalnızca Güneş burcunu bilir; oysa asıl mesele bu üçünün birbiriyle nasıl geçindiğidir.",
        ],
        bolumler: [
          { baslik: "Güneşin — özün",
            vurgu: Dg.cekirdek || "",
            paragraflar: [
              "Güneşin " + gunes + ". Bu senin özün; hayatta ne olmaya geldiğin. " + g.yonetici + " yönetiminde olman, iradeni bu gezegenin diliyle kullandığın anlamına gelir.",
              Dg.oz || "",
            ] },
          { baslik: "Ayın — kimseye göstermediğin taraf",
            paragraflar: [
              "Ayın yaklaşık " + ay + ". Ay duygusal iç dünyanı, güvende hissetme biçimini ve kapıyı kapattığında kim olduğunu yönetir. Zor anlarında otomatik olarak bu tarafa çekilirsin.",
              ay + " Ay'ı taşımak şu demek: " + (Da.oz || "").split(".").slice(0, 2).join(".") + ".",
              "Ay'ın gölgesi de seninle gelir: " + (Da.golge || "").split(".")[0] + ". Bu, Güneş burcunun hiç göstermediği bir taraftır — insanların seni yanlış tanımasının sebebi çoğu zaman budur.",
              "Not: Ay konumu efemeris olmadan yaklaşık hesaplanır. Ay iki buçuk günde bir burç değiştirdiği için, doğum tarihin bir geçiş gününe denk geliyorsa komşu burcu da okumanı öneririm.",
            ] },
          { baslik: y ? "Yükselenin — dünyanın gördüğü yüz" : "Yükselenin — hesaplanamadı",
            paragraflar: y
              ? [
                  "Yükselenin " + yukselen + ". Bu, insanların seninle ilk karşılaştığında gördüğü kapıdır. Maske demek doğru değil; doğduğun an ufukta yükselen burç, senin dünyaya açılma biçimini kurar.",
                  (Dy.cekirdek || "") + " " + (Dy.oz || "").split(".")[0] + ".",
                  "Güneşin " + gunes + ", yükselenin " + yukselen + " olduğu için seni yeni tanıyanlarla yıllardır tanıyanlar çoğu zaman farklı bir insandan bahsediyor gibidir. Bu bir tutarsızlık değil, haritanın normal işleyişi.",
                ]
              : [
                  "Yükselenini hesaplamadım çünkü doğum saatini girmedin. Yükselen, doğum anındaki ufuk çizgisine bağlıdır ve dört dakikalık bir fark bile burcu değiştirebilir.",
                  "Tahmin yürütüp sana yanlış bir yükselen söylemeyi doğru bulmuyorum — çünkü yükselen, haritanın en çok yanlış bilinen ve en çok güvenilen parçasıdır. Doğum saatini nüfus kayıt örneğinden ya da doğum belgenden öğrenebilirsin; sonra testi tekrar çalıştır, üçüncü ışığı da ekleyeyim.",
                ] },
          { baslik: "Üç ışık birbiriyle nasıl geçiniyor",
            paragraflar: [
              KATMAN[katman],
              "Haritanda " + baskinEl + " elementi öne çıkıyor. " + (elSayim[baskinEl] >= 2
                ? "Birden fazla ışığın aynı elementte toplanması, bu niteliğin hayatında baskın bir renk olduğunu gösterir. Güçlüdür ama tek yanlı olma riski taşır; aynı türden tepkiyi her duruma verirsin."
                : "Işıkların farklı elementlere dağılmış. Bu çok yönlü bir yapı verir ama içeride sürekli bir müzakere demektir — bir tarafın istediğini diğeri istemez."),
            ] },
          { baslik: "Bu dönem", vurgu: Dg.donem || "", paragraflar: [] },
        ],
        golge: { baslik: "Haritanın zorlu tarafı", metin: (Dg.golge || "") },
        olcumler: Z.olcumlereCevir(elSayim, null, { "Ateş": "#F0A500", "Toprak": "#8B6914", "Hava": "#63B3ED", "Su": "#4FD1C5" }),
        gerekceler: taslar.slice(0, 6).map(function (anahtar) {
          var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};
          var t = bilgi[anahtar] || {};
          var neden = (Z.BURC_TAS[gunes] || []).indexOf(anahtar) !== -1 ? "Güneş burcun " + gunes + " ile anılan taş."
            : (Z.BURC_TAS[ay] || []).indexOf(anahtar) !== -1 ? "Ay burcun " + ay + " ile anılan taş; duygusal katmanına dönük."
            : (yukselen && (Z.BURC_TAS[yukselen] || []).indexOf(anahtar) !== -1) ? "Yükselenin " + yukselen + " ile anılan taş; dışa dönük yüzünü destekler."
            : "Haritanda baskın olan " + baskinEl + " elementini dengeliyor.";
          return { ad: t.ad || anahtar, renk: t.renk, metin: neden + " " + (t.ozet || "") };
        }),
        taslar: taslar,
        urunGiris: "Üç ışığının burçlarıyla ve baskın " + baskinEl + " elementinle eşleşen stoklu ürünler:",
      };
    },
  };

  /* ============ 3. YILDIZNAME ============ */
  T["yildizname"] = {
    ad: "Yıldızname",
    ustBaslik: "Kadim İlim",
    kapak: "kapak-yildizname.png",
    video: "kozmos-dongu.mp4",
    ozet: "Yıldızname, kişiyi adı ve annesinin adı üzerinden ebced hesabıyla okuyan kadim bir Osmanlı geleneğidir. Harflerin sayısal karşılığı taşınan tabiatı, tabiat ise hayatta tekrar eden döngüyü işaret eder.",
    sure: "5 dakika",
    ciktiEtiket: "Tabiat + kapı",
    girdiler: ["ad", "anneAdi", "dogumTarihi"],
    sorular: [
      { metin: "Hayatında aynı tip olaylar tekrar eder mi?",
        aciklama: "Yıldıznamede tekrar eden döngü, taşınan tabiatın işareti sayılır.",
        secenekler: [
          { etiket: "Evet, hep aynı duvara çarpıyorum", puan: { dongu: 3 } },
          { etiket: "Bazen fark ediyorum", puan: { dongu: 2 } },
          { etiket: "Hayır, her dönem farklı", puan: { akis: 3 } },
          { etiket: "Fark etmemiştim, şimdi düşününce evet", puan: { dongu: 2, ortu: 2 } },
        ] },
      { metin: "İşlerin sana genelde hangi yoldan gelir?",
        secenekler: [
          { etiket: "Tanıdık aracılığıyla", puan: { kapi: 3 } },
          { etiket: "Kendi aradığımda bulurum", puan: { akis: 3 } },
          { etiket: "Beklemediğim anda önüme çıkar", puan: { ortu: 3 } },
          { etiket: "Zorlanarak, ısrarla", puan: { dongu: 3 } },
        ] },
      { metin: "Nazara inanır mısın?",
        secenekler: [
          { etiket: "Kesinlikle, etkisini gördüm", puan: { ortu: 3 } },
          { etiket: "İnanırım ama abartmam", puan: { kapi: 2 } },
          { etiket: "Emin değilim", puan: { akis: 2 } },
          { etiket: "Hayır", puan: { akis: 3 } },
        ] },
      { metin: "Bir işe niyet ettiğinde ne olur?",
        secenekler: [
          { etiket: "Genelde olur, yolunu bulur", puan: { akis: 3 } },
          { etiket: "Son anda bir engel çıkar", puan: { ortu: 3 } },
          { etiket: "Uzun sürer ama sonunda olur", puan: { dongu: 2, kapi: 2 } },
          { etiket: "İstediğim gibi değil, başka türlü olur", puan: { ortu: 2, akis: 2 } },
        ] },
      { metin: "Rüyalarında işaret gördüğün olur mu?",
        secenekler: [
          { etiket: "Sık sık, sonra çıkar", puan: { ortu: 3 } },
          { etiket: "Bazen", puan: { kapi: 2 } },
          { etiket: "Nadiren hatırlarım", puan: { akis: 2 } },
          { etiket: "Hiç", puan: { akis: 3 } },
        ] },
      { metin: "Kalabalık bir ortamdan sonra?",
        secenekler: [
          { etiket: "Ağırlaşırım, üstüme bir şey yapışır", puan: { ortu: 3 } },
          { etiket: "Enerjim yükselir", puan: { akis: 3 } },
          { etiket: "Yorulurum ama geçer", puan: { kapi: 2 } },
          { etiket: "Huzursuz olurum, sebebini bilmem", puan: { ortu: 2, dongu: 2 } },
        ] },
      { metin: "Sana göre kısmetin açılması ne demek?",
        secenekler: [
          { etiket: "Önümdeki görünmez engelin kalkması", puan: { ortu: 3 } },
          { etiket: "Doğru zamanın gelmesi", puan: { akis: 3 } },
          { etiket: "Doğru insanla karşılaşmak", puan: { kapi: 3 } },
          { etiket: "Kendi tavrımın değişmesi", puan: { dongu: 3 } },
        ] },
      { metin: "Şu an hayatında en çok neyi bekliyorsun?",
        secenekler: [
          { etiket: "Bir kapının açılmasını", puan: { kapi: 3 } },
          { etiket: "Bir yükün kalkmasını", puan: { ortu: 3 } },
          { etiket: "Bir düğümün çözülmesini", puan: { dongu: 3 } },
          { etiket: "Beklemiyorum, akışındayım", puan: { akis: 3 } },
        ] },
    ],
    hesapSatirlari: [
      "İsim harfleri ebced tablosuna aktarılıyor…",
      "Anne adının sayısal karşılığı alınıyor…",
      "Toplam, on iki kapıya bölünüyor…",
      "Tabiat ve unsur tayin ediliyor…",
      "Taş karşılıkları çıkarılıyor…",
    ],
    sonuc: function (girdi, cevaplar) {
      var ad = Z.ilkAd(girdi.ad);
      var kisi = Z.harfToplam(girdi.ad, Z.EBCED);
      var anne = Z.harfToplam(girdi.anneAdi, Z.EBCED);
      var toplam = kisi + anne;

      var hal = Z.puanTopla(cevaplar || []);
      ["dongu", "kapi", "ortu", "akis"].forEach(function (k) { if (!hal[k]) hal[k] = 0; });
      var halAnahtar = Z.baskin(hal) || "akis";
      var HAL = {
        dongu: { ad: "Döngü Hâli", renk: "#8B6914",
          metin: "Cevapların, hayatında tekrar eden bir döngü olduğunu gösteriyor. Yıldıznamede buna 'tabiatın kendine benzeri çekmesi' denir: taşıdığın unsur, aynı türden olayları önüne getirir. Döngüyü kıran şey daha çok çabalamak değil, çabanın yönünü değiştirmektir. Aynı kapıyı daha sert çalmak yerine, kilidin başka olduğunu kabul etmek.",
          niyet: ["donusum", "sabir", "berraklik"] },
        kapi: { ad: "Kapı Hâli", renk: "#F0A500",
          metin: "Cevapların, işlerinin insan eliyle geldiğini gösteriyor. Yıldıznamede bazı kişilerin rızkı 'vesile' üzerinden yazılıdır — yani doğru kişiyle karşılaşmadan kapı açılmaz. Bu, çabanın boşa olduğu anlamına gelmez; çabayı nereye yönelteceğini söyler. Senin durumunda ilişki ağı, tek başına gösterilen emekten daha belirleyici.",
          niyet: ["iliski", "ifade", "sans"] },
        ortu: { ad: "Örtü Hâli", renk: "#2D3748",
          metin: "Cevapların, üzerinde bir ağırlık hissettiğini gösteriyor: son anda çıkan engeller, kalabalıktan sonra üstüne yapışan hâl, sebebi bulunmayan huzursuzluk. Gelenekte buna 'örtü' denir ve nazarla ilişkilendirilir. Bu tanım bir teşhis değil, bir tariftir — ama tarif ettiği his gerçektir ve koruma taşları tam da bu his için taşınmıştır.",
          niyet: ["nazar", "koruma", "aritma"] },
        akis: { ad: "Akış Hâli", renk: "#4FD1C5",
          metin: "Cevapların, akışta olduğunu gösteriyor. İşlerin zamanı geldiğinde oluyor, üzerinde ağırlık hissetmiyorsun. Yıldıznamede bu hâl 'açık kapı' diye anılır ve korunması gereken bir durumdur — çünkü kalıcı değildir. Bu dönemde yapacağın işler, sıkışık dönemde yapacaklarından daha az dirençle sonuçlanır.",
          niyet: ["bereket", "niyet", "guclendirme"] },
      };
      var H = HAL[halAnahtar];

      var sira = Object.keys(Z.BURCLAR);
      var kapi = sira[toplam % 12];
      var k = Z.BURCLAR[kapi];

      // Dört tabiat: ebced toplamının dörde bölümünden tayin edilir
      var tabiatlar = [
        { ad: "Ateşî", el: "Ateş", huy: "hareketli, atılgan ve çabuk tutuşan", ogut: "Acele ettiğin yerde bir nefes almayı öğrenmen, önündeki çoğu kapıyı açar." },
        { ad: "Toprakî", el: "Toprak", huy: "sabırlı, ağır ve kalıcı", ogut: "Kurduğun düzene fazla yapışmaman, seni beklediğin bereketle buluşturur." },
        { ad: "Havaî", el: "Hava", huy: "zihni hızlı, iletişimi güçlü ve değişken", ogut: "Dağıttığın dikkati bir noktaya toplaman, uzun süredir istediğin sonucu getirir." },
        { ad: "Suyî", el: "Su", huy: "hassas, sezgisi kuvvetli ve derin", ogut: "Herkesin yükünü sırtlanmaman, kendi suyunu berrak tutar." },
      ];
      var tabiat = tabiatlar[toplam % 4];

      var taslar = Z.birlestir(
        Z.ELEMENT_TAS[tabiat.el].slice(0, 3),
        Z.BURC_TAS[kapi].slice(0, 2),
        Z.niyetTaslari(H.niyet, 3)
      );

      var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};

      return {
        ustBaslik: "Yıldıznamen",
        baslik: tabiat.ad + " Tabiat",
        altBaslik: kapi + " kapısı · " + H.ad + " · ebced " + toplam,
        vurgu: "Yıldıznamede kişi tek başına okunmaz; adı, annesinin adı ve içinde bulunduğu hâl birlikte okunur.",
        rozetler: [
          { etiket: "İsim ebcedi", deger: String(kisi) },
          { etiket: "Anne ebcedi", deger: String(anne) },
          { etiket: "Tabiat", deger: tabiat.ad },
          { etiket: "Hâl", deger: H.ad.split(" ")[0] },
        ],
        metin: [
          ad + ", yıldızname geleneğinde kişi yalnız kendi adıyla değil, annesinin adıyla birlikte okunur. Bunun sebebi, anne adının kişinin dünyaya geldiği kapıyı işaret ettiğine inanılmasıdır. Baba adı değil anne adı sorulur; çünkü doğum, anneden gelen kesin bir bilgidir.",
        ],
        bolumler: [
          { baslik: "Hesap",
            paragraflar: [
              "Adının ebced karşılığı " + kisi + ", annenin adının karşılığı " + anne + ". Toplamın " + toplam + " ediyor.",
              "Bu sayı iki şeye bölünür: on ikiye bölümünden kalan seni " + kapi + " kapısına, dörde bölümünden kalan " + tabiat.ad + " tabiata düşürüyor. Ebced tablosu Osmanlı geleneğindeki yaygın karşılıklara dayanıyor; farklı tablolar farklı sonuç verebilir, bu ilmin doğasında olan bir çeşitliliktir.",
            ] },
          { baslik: "Tabiatın",
            paragraflar: [
              tabiat.ad + " tabiat, " + tabiat.huy + " bir mizacı işaret eder. Bu geleneğe göre insanın tabiatı yalnızca huyunu değil, hayatındaki tekrar eden döngüleri de belirler — aynı tip olayların başına gelmesi tesadüf sayılmaz, taşınan unsurun kendine benzeri çekmesi sayılır.",
              "Öğüt: " + tabiat.ogut,
            ] },
          { baslik: "Kapın",
            paragraflar: [
              kapi + " kapısı dışa açıldığın yönü gösterir. " + k.ozet.charAt(0).toLocaleUpperCase("tr") + k.ozet.slice(1) + " bir yönelim; işlerin sana bu kapıdan gelir.",
              "Kapı, tabiatın gölgesini dengeleyen taraftır. " + tabiat.ad + " tabiat " + kapi + " kapısıyla birleştiğinde, mizacının ham hâli biraz yumuşar ve dışarıya daha dengeli yansır.",
            ] },
          { baslik: "İçinde bulunduğun hâl",
            vurgu: H.ad,
            paragraflar: [H.metin] },
        ],
        golge: { baslik: "Bu ilim hakkında", metin: "Yıldızname bir kehanet aracı değil, kendini tanımak için kullanılan sembolik bir okuma biçimidir. Gelecek hakkında kesin hüküm vermez; taşıdığın mizacı ve o mizacın seni tekrar tekrar getirdiği yeri gösterir. Kararlarını buna göre değil, kendi muhakemenle vermelisin." },
        olcumler: Z.olcumlereCevir(hal, { dongu: "Döngü", kapi: "Vesile", ortu: "Örtü", akis: "Akış" },
          { dongu: "#8B6914", kapi: "#F0A500", ortu: "#2D3748", akis: "#4FD1C5" }),
        gerekceler: taslar.slice(0, 6).map(function (a) {
          var t = bilgi[a] || {};
          var neden = (Z.ELEMENT_TAS[tabiat.el] || []).indexOf(a) !== -1 ? tabiat.ad + " tabiatının " + tabiat.el + " unsurunu dengeliyor."
            : (Z.BURC_TAS[kapi] || []).indexOf(a) !== -1 ? kapi + " kapısıyla geleneksel olarak anılıyor."
            : H.ad + " için seçildi.";
          return { ad: t.ad || a, renk: t.renk, metin: neden + " " + (t.ozet || "") };
        }),
        taslar: taslar,
        urunGiris: tabiat.ad + " tabiatını dengeleyen, " + kapi + " kapısını koruyan ve " + H.ad.toLocaleLowerCase("tr") + "ne dönük taşlar:",
      };
    },
  };

  /* ============ 4. NUMEROLOJİ ============ */
  var YASAM_YOLU = {
    1: { ad: "Öncü", ozet: "Bağımsızlık, başlatma gücü ve liderlik", niyet: ["ozguven", "cesaret", "basari"],
         iliski: "İlişkide baskın taraf olmaya eğilimlisin; eşit güçte biri seni hem zorlar hem büyütür.", kariyer: "Yalnız çalışabildiğin, kararı sana ait olan işler. Onay beklemek seni yavaşlatır.", ders: "Yardım istemenin zayıflık olmadığını öğrenmek.",
         metin: "Sen yolu açan sayısın. Kimsenin gitmediği yere ilk adımı atmak sana doğal gelir. Zorlandığın yer ise başkasına ihtiyaç duyduğunu kabul etmek." },
    2: { ad: "Uzlaştırıcı", ozet: "Denge, ortaklık ve sezgisel diplomasi", niyet: ["denge", "iliski", "sefkat"],
         iliski: "İlişki senin doğal alanın ama kendini karşındakinde kaybetme riskin yüksek.", kariyer: "Ortaklık, arabuluculuk, ekip içi denge kurulan roller.", ders: "Kendi isteğini, kimseyi kırma kaygısı olmadan söyleyebilmek.",
         metin: "İki tarafı da görebilen nadir bir sayısın. Bu bir üstünlük ama aynı zamanda yük; herkesi memnun etme çabası seni kendinden uzaklaştırabilir." },
    3: { ad: "İfade", ozet: "Yaratıcılık, söz ve neşe", niyet: ["yaraticilik", "ifade", "nese"],
         iliski: "Neşenle çekersin ama derinleşmesi gereken yerde şakaya sığınabilirsin.", kariyer: "Söz, görsel, tasarım, sahne — ifadenin para ettiği her alan.", ders: "İfade edilmeyen duygunun kaybolmadığını, biriktiğini fark etmek.",
         metin: "Sende bir şey daima dışa vurulmak ister — söz, renk, tasarım, ses. İfade edemediğinde ağırlaşırsın. Yaratıcılığın bir hobi değil, dengen." },
    4: { ad: "İnşa Eden", ozet: "Düzen, emek ve sağlam temel", niyet: ["topraklanma", "dayaniklilik", "sabir"],
         iliski: "Sadıksın, güven verirsin; ama duygusal esneklik göstermen zaman alır.", kariyer: "Sistem kuran, uzun vadeli, elle tutulur sonuç üreten işler.", ders: "Kurduğun yapının seni de içeride bırakabileceğini görmek.",
         metin: "Kalıcı olanı sen kurarsın. Diğerleri hayal ederken sen temeli atarsın. Riskin, kurduğun yapının içinde sıkışıp kalman." },
    5: { ad: "Özgürlük", ozet: "Değişim, hareket ve deneyim", niyet: ["yeni-baslangic", "yolculuk", "donusum"],
         iliski: "Bağlanmakla özgürlük arasında gerilim yaşarsın; sıkıştığında kaçarsın.", kariyer: "Seyahat, satış, medya, sürekli değişen ortamlar.", ders: "Özgürlüğün kaçmak değil, kalmayı seçebilmek olduğunu anlamak.",
         metin: "Sabit olan her şey seni daraltır. Hayatın sana defalarca yer değiştirtir. Öğrenmen gereken, özgürlüğün kaçmak değil seçmek olduğu." },
    6: { ad: "Koruyucu", ozet: "Sorumluluk, sevgi ve yuva", niyet: ["sevgi", "iliski", "sefkat"],
         iliski: "Taşıyan taraf sensin; verirken kendini listenin sonuna koyarsın.", kariyer: "İnsanla ilgilenen, koruyan, iyileştiren, eğiten roller.", ders: "Sorumluluğun sınırının nerede bittiğini çizebilmek.",
         metin: "Etrafındakileri sen taşırsın. Bu senin en güzel ve en yorucu tarafın. Kendini listenin sonuna koyma alışkanlığı, taşıdığın en ağır yük." },
    7: { ad: "Arayıcı", ozet: "Derinlik, sezgi ve içe bakış", niyet: ["sezgi", "bilgelik", "berraklik"],
         iliski: "Yakınlığa alan gerekir; sessizliğin reddedilme sanılabilir.", kariyer: "Araştırma, uzmanlık, analiz, derinlik isteyen alanlar.", ders: "Anlamı ararken hayatın kendisini ıskalamamak.",
         metin: "Yüzeyle yetinmezsin. Kalabalıkta bile yalnız kalabilirsin ve bu seni rahatsız etmez. Riskin, anlamı ararken hayatın kendisini ıskalaman." },
    8: { ad: "Güç", ozet: "Maddi ustalık, otorite ve bereket", niyet: ["bolluk", "basari", "guc"],
         iliski: "Güç dengesi ilişkilerinde de belirleyicidir; kontrolü paylaşmak zor gelir.", kariyer: "Yönetim, finans, girişim, ölçek büyüten işler.", ders: "Aracın amaç hâline geldiği anı fark edebilmek.",
         metin: "Maddi dünyayı yönetme kabiliyetin var. Para ve statü senin için araç; ama araç amaç olduğunda sayının gölge yüzü devreye girer." },
    9: { ad: "Bilge", ozet: "Tamamlama, şefkat ve bırakma", niyet: ["bilgelik", "affetme", "iyilesme"],
         iliski: "Çok verirsin, karşılığını beklemediğini söylersin ama beklersin.", kariyer: "Danışmanlık, sanat, sosyal fayda üreten alanlar.", ders: "Bırakmanın kayıp değil, tamamlanma olduğunu kabul etmek.",
         metin: "Döngüleri sen kapatırsın. Hayatın sana defalarca bırakmayı öğretir. Verdiğin çok, aldığın az görünür — ama hesabın başka bir defterde tutulur." },
    11: { ad: "Usta Sezgi", ozet: "Yüksek sezgi ve ilham", niyet: ["sezgi", "hizalanma", "berraklik"],
         iliski: "Sezgin ilişkide de çalışır; hissettiğini anlatamamak seni yalnızlaştırır.", kariyer: "İlham veren, öğreten, yol gösteren roller.", ders: "Hassasiyetini yük değil, araç olarak kullanmayı öğrenmek.",
         metin: "Usta sayı taşıyorsun. Sezgin çoğu insandan hızlı çalışır ama bu bir yük olarak da gelir; hissettiğini açıklayamamak seni yorar." },
    22: { ad: "Usta İnşacı", ozet: "Büyük ölçekli kurma gücü", niyet: ["basari", "dayaniklilik", "topraklanma"],
         iliski: "Büyük hedeflerin ilişkine yer bırakmayabilir; dengeyi bilinçli kurman gerekir.", kariyer: "Büyük ölçekli inşa, kurumsal yapı, uzun vadeli proje.", ders: "Hayali gerçeğe çevirirken kendini harcamamak.",
         metin: "Usta sayıların en zorlusunu taşıyorsun. Hayalle gerçeği aynı anda tutabilen nadir bir yapıdasın; yükü de ona göre ağırdır." },
    33: { ad: "Usta Öğretmen", ozet: "Şefkatle yol gösterme", niyet: ["sefkat", "sevgi", "bilgelik"],
         iliski: "Şefkatin sınırsız görünür; sınır koymadığında istismara açık kalırsın.", kariyer: "Öğretmek, iyileştirmek, topluluk kurmak.", ders: "Herkese yetişmeye çalışmanın kimseye yetişememek olduğunu görmek.",
         metin: "En ender usta sayı. Öğretmek için değil, olduğun gibi durarak yol gösterirsin. Kendine ayırdığın alan daima yetersiz kalır." },
  };

  T["numeroloji"] = {
    ad: "Numeroloji",
    ustBaslik: "Sayı Haritası",
    kapak: "kapak-numeroloji.png",
    video: "kozmos-dongu.mp4",
    ozet: "Doğum tarihin yaşam yolu sayını, adının harfleri ise kader sayını verir. İkisi birlikte hayatının tekrar eden temasını gösterir.",
    sure: "1 dk",
    ciktiEtiket: "Yaşam yolu + kader sayısı",
    girdiler: ["ad", "dogumTarihi"],
    hesapSatirlari: [
      "Doğum tarihi rakamlarına ayrılıyor…",
      "Yaşam yolu sayısı indirgeniyor…",
      "İsim harfleri sayısal karşılıklarına çevriliyor…",
      "Kader sayısı hesaplanıyor…",
    ],
    sonuc: function (girdi) {
      var ad = Z.ilkAd(girdi.ad);
      var yol = Z.yasamYolu(girdi.dogumTarihi);
      var kader = Z.indirge(Z.harfToplam(girdi.ad, Z.PISAGOR), true);

      var y = YASAM_YOLU[yol] || YASAM_YOLU[1];
      var k = YASAM_YOLU[kader] || YASAM_YOLU[1];
      var ayni = yol === kader;

      // Yaşam yolu ile kader sayısı aynı olduğunda iki liste birebir örtüşür;
      // tekrarlar elenince liste zayıflar. Bu yüzden fazladan istiyor ve
      // her iki durumda da dengeleyici taşlarla tamamlıyoruz.
      var taslar = Z.birlestir(
        Z.niyetTaslari(y.niyet, 4),
        Z.niyetTaslari(k.niyet, 4),
        Z.niyetTaslari(["denge", "berraklik"], 2)
      );

      return {
        ustBaslik: "Sayı Haritan",
        baslik: yol + " · " + y.ad,
        altBaslik: "Kader sayın " + kader + " · " + k.ad,
        rozetler: [
          { etiket: "Yaşam yolu", deger: String(yol) },
          { etiket: "Kader sayısı", deger: String(kader) },
          { etiket: "Tema", deger: y.ozet.split(",")[0] },
          { etiket: "Örüntü", deger: ayni ? "Tek yönlü" : "İki katmanlı" },
        ],
        vurgu: "Yaşam yolu değiştirilemez; kader sayısı ise o yolu hangi araçla yürüdüğünü söyler.",
        metin: [
          ad + ", numerolojide iki temel sayı vardır. Yaşam yolu doğum tarihinden çıkar ve hiçbir zaman değişmez — hayatın sana hangi dersi tekrar tekrar getireceğini gösterir. Kader sayısı ise adının harflerinden çıkar ve o yolu nasıl yürüdüğünü anlatır.",
        ],
        bolumler: [
          { baslik: "Yaşam yolun — " + yol,
            vurgu: y.ozet,
            paragraflar: [
              y.metin,
              "Bu sayı doğum tarihinin rakamlarının indirgenmesiyle bulunur. " + (yol === 11 || yol === 22 || yol === 33
                ? "Seninki bir usta sayı; indirgeme burada durur. Usta sayılar daha yüksek bir potansiyel taşıdıkları kadar daha ağır bir yük de taşırlar."
                : "Tek haneye indiği için okuması nettir; usta sayıların ikircikliği sende yok."),
            ] },
          { baslik: "Kader sayın — " + kader,
            paragraflar: [
              k.metin,
              "Kader sayısı adının harflerinden çıkar. Adın değişirse bu sayı da değişir — geleneksel yaklaşımda isim değiştirmenin kaderi değiştirdiği inancı buradan gelir.",
            ] },
          { baslik: "İki sayının ilişkisi",
            vurgu: ayni ? "Yolun ile aracın aynı." : y.ad + " olarak yürüyor, " + k.ad + " olarak görünüyorsun.",
            paragraflar: [
              ayni
                ? "Yaşam yolun ve kader sayın aynı çıktı. Bu, yolun ile aracının örtüştüğü anlamına gelir — çok net ama çok yoğun bir yapı. Bu sayının hem gücünü hem gölgesini tam dozunda yaşarsın, ara ton azdır. Avantajı tutarlılık, riski ise tek bir kalıba sıkışmak."
                : "İki sayının farklı olması sana iki katmanlı bir yapı verir. İçeride " + y.ad + " yürüyor, dışarıya " + k.ad + " görünüyorsun. Bu mesafe, zaman zaman kendini anlaşılmamış hissetmenin sebebidir: insanlar kader sayını görüyor, sen yaşam yolunu yaşıyorsun.",
            ] },
          { baslik: "İlişkilerde", paragraflar: [y.iliski || ""] },
          { baslik: "Çalışma alanın", paragraflar: [y.kariyer || ""] },
          { baslik: "Kişisel yılın",
            paragraflar: [
              (function () {
                var t = Z.tariheCevir(girdi.dogumTarihi);
                if (!t) return "";
                var yil = 2026;
                var ky = Z.indirge(Z.indirge(t.gun, false) + Z.indirge(t.ay, false) +
                  Z.indirge(String(yil).split("").reduce(function (a, b) { return a + (+b); }, 0), false), false);
                var KY = {
                  1: "yeni bir döngünün başladığı, tohum atma yılı. Bu yıl attığın adımlar önümüzdeki dokuz yılı şekillendirir.",
                  2: "sabır ve ortaklık yılı. Hızlanmaya çalışmak yerine ilişkileri kurmak ve beklemek daha verimli olur.",
                  3: "ifade ve görünürlük yılı. Ürettiğini paylaşmak, sesini duyurmak için iyi bir dönem.",
                  4: "emek ve temel atma yılı. Sonuç yavaş gelir ama kalıcı olur; bu yıl kurulan yapı uzun süre durur.",
                  5: "değişim ve hareket yılı. Beklenmedik fırsatlar ve yer değiştirmeler tipiktir; katılık zarar verir.",
                  6: "sorumluluk ve yuva yılı. Aile, ilişki ve bakım konuları öne çıkar; kendini ihmal etme riski yüksektir.",
                  7: "içe dönüş ve öğrenme yılı. Dışarıda sonuç aramak yerine bilgiyi derinleştirmek daha isabetlidir.",
                  8: "hasat ve maddi sonuç yılı. Önceki yılların emeği bu dönemde karşılık bulmaya eğilimlidir.",
                  9: "tamamlanma ve bırakma yılı. Biten şeyleri zorla tutmamak, yeni döngüye temiz girmeni sağlar.",
                };
                return "2026 senin için " + ky + " numaralı kişisel yıl — " + KY[ky];
              })(),
              "Kişisel yıl, doğum gününle içinde bulunulan yılın toplamından çıkar ve dokuz yıllık bir döngü içinde ilerler. Yaşam yolu sabit kalırken kişisel yıl her sene değişir; bu ikisini birlikte okumak, o yıl neye ağırlık vermen gerektiğini gösterir.",
            ] },
          { baslik: "Bu sayının dersi", vurgu: y.ders || "", paragraflar: [] },
        ],
        golge: { baslik: "Sayının gölgesi", metin: (y.metin || "").split(".").slice(-2).join(".").trim() + " Numerolojide her sayının gücü, aşırıya kaçtığında kendi zıddına dönüşür; " + yol + " sayısı için bu eşik özellikle belirgindir." },
        gerekceler: taslar.slice(0, 6).map(function (a) {
          var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};
          var t = bilgi[a] || {};
          return { ad: t.ad || a, renk: t.renk, metin: yol + " ve " + kader + " sayılarının niyetleriyle eşleşiyor. " + (t.ozet || "") };
        }),
        taslar: taslar,
        urunGiris: yol + " yaşam yolu ve " + kader + " kader sayınla eşleşen taşlar:",
      };
    },
  };

  /* ============ 5. MARİFETNÂME ============ */
  T["marifetname"] = {
    ad: "Marifetnâme",
    ustBaslik: "Dört Unsur İlmi",
    kapak: "kapak-marifetname.png",
    video: "kozmos-dongu.mp4",
    ozet: "Erzurumlu İbrahim Hakkı'nın Marifetnâme'sinde insan dört unsur ve dört mizaç üzerinden okunur. Hangi mizacın baskın, hangisi eksik?",
    sure: "3 dk",
    ciktiEtiket: "Mizaç dengesi",
    girdiler: ["ad", "dogumTarihi"],
    hesapSatirlari: [
      "Dört unsur tartılıyor…",
      "Mizaç oranları çıkarılıyor…",
      "Baskın ve eksik unsur belirleniyor…",
      "Dengeleyici taşlar seçiliyor…",
    ],
    sorular: [
      { metin: "Sabah uyandığında hâlin genelde nasıldır?",
        secenekler: [
          { etiket: "Enerjik, hemen harekete geçerim", puan: { safra: 3 } },
          { etiket: "Ağır ağır açılırım, acele etmem", puan: { balgam: 3 } },
          { etiket: "Zihnim hemen çalışmaya başlar", puan: { kan: 3 } },
          { etiket: "Rüyalarımın etkisi sürer, içe dönük başlarım", puan: { sevda: 3 } },
        ] },
      { metin: "Öfkelendiğinde ne olur?",
        secenekler: [
          { etiket: "Anında parlarım, çabuk da geçer", puan: { safra: 3 } },
          { etiket: "Belli etmem, susarım", puan: { balgam: 3 } },
          { etiket: "Konuşarak boşaltırım, tartışırım", puan: { kan: 3 } },
          { etiket: "İçime atarım, uzun süre kalır", puan: { sevda: 3 } },
        ] },
      { metin: "Kalabalık bir davette kendini nasıl bulursun?",
        secenekler: [
          { etiket: "Ortamın merkezinde", puan: { kan: 3 } },
          { etiket: "Bir köşede, birkaç kişiyle derin sohbette", puan: { sevda: 3 } },
          { etiket: "Organize eden, işleri yürüten tarafta", puan: { safra: 2 } },
          { etiket: "Sakin, izleyen, rahatsız etmeyen tarafta", puan: { balgam: 3 } },
        ] },
      { metin: "Bir işe girişmeden önce?",
        secenekler: [
          { etiket: "Başlarım, yolda düzeltirim", puan: { safra: 3 } },
          { etiket: "Uzun uzun düşünürüm, çoğu zaman ertelerim", puan: { sevda: 3 } },
          { etiket: "Etrafımdakilere danışırım", puan: { kan: 2 } },
          { etiket: "Acele etmem, zamanı gelince yaparım", puan: { balgam: 3 } },
        ] },
      { metin: "Seni en iyi hangisi tarif eder?",
        secenekler: [
          { etiket: "Sıcak ve kuru — hızlı, keskin", puan: { safra: 3 } },
          { etiket: "Soğuk ve nemli — sakin, yumuşak", puan: { balgam: 3 } },
          { etiket: "Sıcak ve nemli — canlı, sosyal", puan: { kan: 3 } },
          { etiket: "Soğuk ve kuru — derin, ölçülü", puan: { sevda: 3 } },
        ] },
    ],
    sonuc: function (girdi, cevaplar) {
      var ad = Z.ilkAd(girdi.ad);
      var puan = Z.puanTopla(cevaplar);
      ["safra", "balgam", "kan", "sevda"].forEach(function (k) { if (!puan[k]) puan[k] = 0; });

      var MIZAC = {
        safra:  { ad: "Safravî", unsur: "Ateş",   nitelik: "sıcak ve kuru",   huy: "hızlı, keskin, karar alan", eksikOgut: "Ateşin fazlaysa serinletici olan seni dengeler.", niyet: ["sakinlik", "denge", "sabir"] },
        balgam: { ad: "Balgamî", unsur: "Su",     nitelik: "soğuk ve nemli",  huy: "sakin, yumuşak, uzlaşmacı", eksikOgut: "Suyun fazlaysa hareket ve ısı seni canlandırır.", niyet: ["motivasyon", "cesaret", "nese"] },
        kan:    { ad: "Demevî",  unsur: "Hava",   nitelik: "sıcak ve nemli",  huy: "canlı, sosyal, iyimser", eksikOgut: "Havan fazlaysa topraklanma seni yere indirir.", niyet: ["topraklanma", "odak", "denge"] },
        sevda:  { ad: "Sevdavî", unsur: "Toprak", nitelik: "soğuk ve kuru",   huy: "derin, ölçülü, düşünen", eksikOgut: "Toprağın fazlaysa hafiflik ve ifade sana iyi gelir.", niyet: ["ifade", "nese", "yaraticilik"] },
      };

      var baskinK = Z.baskin(puan);
      var eksikK = Object.keys(puan).sort(function (a, b) { return puan[a] - puan[b]; })[0];
      var B = MIZAC[baskinK], E = MIZAC[eksikK];

      var taslar = Z.birlestir(Z.niyetTaslari(B.niyet, 3), Z.ELEMENT_TAS[E.unsur].slice(0, 3));

      var adlar = {}; for (var k in MIZAC) adlar[k] = MIZAC[k].ad + " (" + MIZAC[k].unsur + ")";

      return {
        ustBaslik: "Mizaç Haritan",
        baslik: B.ad + " Mizaç",
        altBaslik: B.unsur + " unsuru · " + B.nitelik,
        rozetler: [
          { etiket: "Baskın", deger: B.ad },
          { etiket: "Unsur", deger: B.unsur },
          { etiket: "Nitelik", deger: B.nitelik },
          { etiket: "Eksik", deger: E.ad },
        ],
        vurgu: "Marifetnâme'de denge, baskını bastırmakla değil eksiği beslemekle kurulur.",
        metin: [
          ad + ", Erzurumlu İbrahim Hakkı'nın 1757'de tamamladığı Marifetnâme, insanı dört halt ve dört unsur üzerinden okur. Bu bir sağlık sınıflaması değil, mizaç okumasıdır — kişinin dünyayla hangi ısı ve hangi nemle temas ettiğini anlatır.",
        ],
        bolumler: [
          { baslik: "Baskın mizacın",
            vurgu: B.ad + " · " + B.unsur + " · " + B.nitelik,
            paragraflar: [
              "Sende baskın olan " + B.ad + " mizaç, yani " + B.unsur + " unsuru. Klasik metinlerde niteliği " + B.nitelik + " diye tarif edilir. Bu mizaç " + B.huy + " bir yapı verir; çevrenin sende ilk fark ettiği şey büyük ihtimalle budur.",
              "Marifetnâme'de mizaç sabit kabul edilir ama tezahürü değişkendir. Yani " + B.ad + " olmak değiştirilemez; ancak o mizacın ham hâlde mi yoksa terbiye edilmiş hâlde mi yaşandığı kişiye bağlıdır. Kitabın asıl konusu da budur: mizacı yok etmek değil, ona binmeyi öğrenmek.",
            ] },
          { baslik: "Eksik kalan unsurun",
            paragraflar: [
              "En düşük puanı " + E.ad + " mizaç, yani " + E.unsur + " unsuru aldı. " + E.eksikOgut,
              "Klasik yaklaşımda hastalık da sağlık da unsurların oranıyla açıklanır; ama burada söz konusu olan tıbbi bir durum değil, davranış eğilimidir. Eksik unsur, hayatında sürekli zorlandığın alanı işaret eder — çünkü orada doğal bir donanımın yok, sonradan öğrenmen gerekiyor.",
            ] },
          { baslik: "Dört unsurun dengesi",
            paragraflar: [
              "Bu gelenekte dört unsurun tamamen eşitlenmesi hedef değildir; zaten mümkün de değildir. Herkeste bir unsur önde olur, o kişinin karakterini kurar. Amaç, baskın unsurun seni tek başına yönetmesine izin vermeyecek kadar diğerlerine yer açmaktır.",
              "Senin durumunda " + B.unsur + " ile " + E.unsur + " arasındaki mesafe belirgin. İbrahim Hakkı bu tür açıklıklar için 'zıddıyla terbiye' ilkesini önerir: baskın olanı bastırmak yerine, karşıtını besleyerek dengeyi kurmak.",
            ] },
          { baslik: "Taş seçimi neden böyle",
            paragraflar: [
              "Aşağıdaki taşlar iki işi birden yapıyor: " + B.ad + " mizacını yumuşatan taşlar ile eksik kalan " + E.unsur + " unsurunu besleyen taşlar bir arada seçildi. Tek yönlü bir seçim baskını daha da artırırdı.",
            ] },
        ],
        golge: { baslik: "Mizacın gölge yüzü", metin: B.ad + " mizacın terbiye edilmediğinde " + (baskinK === "safra" ? "aceleye ve öfkeye, kararı düşünmeden vermeye dönüşür" : baskinK === "balgam" ? "atalete ve erteleme alışkanlığına dönüşür; harekete geçmek için gereken eşik yükselir" : baskinK === "kan" ? "dağınıklığa ve yüzeyselliğe dönüşür; her şeye ilgi duyup hiçbirinde derinleşememeye" : "karamsarlığa ve aşırı içe kapanmaya dönüşür; düşünmek eyleme geçmenin yerini alır") + ". Kendini bu hâlde bulduğunda, mizacın seni değil senin mizacını yönetmen gerektiğinin işaretidir." },
        olcumler: Z.olcumlereCevir(puan, adlar, { safra: "#F0A500", balgam: "#4FD1C5", kan: "#F56565", sevda: "#8B6914" }),
        taslar: taslar,
        urunGiris: B.ad + " mizacını dengeleyen ve " + E.unsur + " unsurunu besleyen taşlar:",
      };
    },
  };
})();
